import { useEffect, useState } from 'react';

import { useModal } from 'context/ModalContext';
import { ConfirmacaoDaAcao, ResultadoDaAcao } from 'components/task-item/modal-actions/moldura-da-acao';

interface Props {
  callback: (obj: { id: string; message?: string }) => void;
  id: string;
  status: string | undefined;
  data?: any;
}

/** Validar a Ação ECOA (ECN-57): mesmo texto, passos e retorno do modal antigo, na moldura da nova identidade. */
export default function ModalAccept(props: Props) {
  const modalID = 'validation-accept';

  const { openModal, closeModal } = useModal();
  const { callback, id } = props;

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [success, setSuccess] = useState(false);

  function handleClose() {
    closeModal();
    if (!!success) callback({ id: 'open_feedback' });
  }

  useEffect(() => {
    if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}`) {
      setSuccess(false);
      setIsOpen(true);
    } else if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}-finish`) {
      setSuccess(true);
      setIsOpen(true);
    } else {
      setSuccess(false);
      setIsOpen(false);
    }
  }, [id, openModal]);

  if (!modalIsOpen) return <></>;

  if (success) {
    return (
      <ResultadoDaAcao title="Mandou bem!" onClose={handleClose}>
        Sua validação foi realizada com sucesso.
      </ResultadoDaAcao>
    );
  }

  return (
    <ConfirmacaoDaAcao
      title="Rumo à próxima etapa!"
      onClose={handleClose}
      onConfirm={() => {
        callback({ id: 'accept' });
        closeModal();
      }}
    >
      <p className="m-0">
        Ao validar uma Ação ECOA, ela receberá 100 pontos e concorrerá a bonificação. Lembre-se, você pode validar 1 (uma) Ação
        ECOA a cada mês.
      </p>
    </ConfirmacaoDaAcao>
  );
}
